<template>
  <div>
    <b-modal
      v-model="showModal"
      ref="alertModal"
      hide-footer
      centered
      @hidden="hide"
      header-class="custom-modal-header"
    >
      <template #modal-header>
        <p class="text-header mb-0 my-auto">Assign To</p>
        <b-button
          type="button"
          aria-label="Close"
          variant="close"
          class="px-0 py-1"
          @click="hide"
        >
          <font-awesome-icon icon="times" title="Delete" />
        </b-button>
      </template>
      <div class="text-center">
        <div v-if="!isLoading">
          <b-img
            v-if="imgQrCode"
            class="qr-code-agent"
            :src="imgQrCode"
            :alt="name"
          />
        </div>
        <b-button
          class="mt-3 btn-modal-submit"
          variant="purple"
          @click="download"
          >Download</b-button
        >
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: true,
      showModal: false,
      name: "",
      imgQrCode: "",
    };
  },
  methods: {
    async show(item) {
      this.isLoading = true;
      this.imgQrCode = "";
      this.name = `${item.firstname} ${item.lastname}`;
      await this.getQrCode(item);
      this.showModal = true;
      this.isLoading = false;
    },
    hide() {
      this.showModal = false;
      this.isLoading = true;
    },
    getQrCode: async function (item) {
      let body = {
        adminGuid: item.userGUID
      };
      const url = `${this.$baseUrl}/user/get-qrcode-base64`;
      await this.axios
        .post(url, body)
        .then((data) => {
          if (data.result === 1) {
            this.imgQrCode = `${data.detail}`;
          } else {
            this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
              isShow: true,
              msg: data.message,
            });
          }
        })
        .catch((error) => {
          console.log(error);
          this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
            isShow: true,
            msg: error.message,
          });
        });
    },
    download() {
      var img = new Image();
      img.src = this.imgQrCode;
      img.crossOrigin = "Anonymous";

      img.onload = () => {
        var canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        var ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);
        let dataURL = canvas.toDataURL();

        var fileLink = document.createElement("a");
        fileLink.href = dataURL;
        fileLink.setAttribute("download", `qr-code-${this.name}.png`);
        document.body.appendChild(fileLink);
        fileLink.click();
      };
    },
  },
};
</script>

<style scoped>
.modal-header {
  border: 0 !important;
  padding: 0;
}
.text-text {
  color: #242424;
  margin-bottom: 0;
  font-size: 26px;
}
.modal-body {
  margin: auto;
  text-align: center;
}
.qr-code-agent {
  width: 75%;
}
@media (max-width: 767.98px) {
  /* .text-text {
    font-size: 15px;
  } */
}
</style>
